import { DISABLE_AUTHENTICATION } from '@verona/utils';

export const authenticationIsDisabled = () =>
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  DISABLE_AUTHENTICATION?.toLowerCase() === 'true';
